import { render, staticRenderFns } from "./salesInvoiceDetail.vue?vue&type=template&id=477c3ec2&scoped=true&"
import script from "./salesInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./salesInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./salesInvoiceDetail.vue?vue&type=style&index=0&id=477c3ec2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c3ec2",
  null
  
)

export default component.exports